import { useCallback } from 'react';
import moment from 'moment';

/**
 * Rotulo curto de quando a conversa teve a ultima mensagem.
 *
 * O moment ja e dependencia do projeto (usado em Utils/format.js), entao nao ha
 * biblioteca de data nova aqui. Os rotulos sao montados a mao em vez de usar
 * fromNow(): alem de "ha 3 dias" ser longo demais para a coluna estreita do
 * item, fromNow() exigiria carregar o locale pt-br so para isto.
 */
const useListaConversasHook = () => {
  const formatarTempoRelativo = useCallback(iso => {
    if (!iso) {
      return '';
    }

    const data = moment(iso);

    if (!data.isValid()) {
      return '';
    }

    const agora = moment();

    if (agora.diff(data, 'minutes') < 5) {
      return 'agora';
    }

    if (data.isSame(agora, 'day')) {
      return data.format('HH:mm');
    }

    if (data.isSame(agora.clone().subtract(1, 'day'), 'day')) {
      return 'ontem';
    }

    // clone() antes de startOf: o moment MUTA o objeto, e 'agora' ja foi usado
    // nas comparacoes acima.
    const dias = agora.clone().startOf('day').diff(data.clone().startOf('day'), 'days');

    return dias < 7 ? `${dias} dias` : data.format('DD/MM');
  }, []);

  return { formatarTempoRelativo };
};

export default useListaConversasHook;
